import { getScopeType, needsPartnerPicker, needsStudentPicker } from 'pages/reports/utils/scopePolicy';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { FormattedMessage, useIntl } from 'react-intl';

interface ReportScopeBannerProps {
    highestRoleId: number;
    onChangeScope: () => void;
    scopeId: number;
    scopeObject: { Id: number; Name: string };
}

export const ReportScopeBanner = ({ highestRoleId, onChangeScope, scopeId, scopeObject }: ReportScopeBannerProps) => {

    const { formatMessage } = useIntl();

    const scope = getScopeType(scopeId);
    const canChange = needsStudentPicker(scopeId) || needsPartnerPicker(scopeId, highestRoleId);

    if (scope === 'none' || scope === 'self') return null;

    const label = scope === 'student'
        ? (formatMessage({ id: 'student.a2effdfe', defaultMessage: 'Student:' }))
        : (formatMessage({ id: 'partner.cc87dea0', defaultMessage: 'Partner:' }));

    return (
        <div className="report-scope-banner align-items-center d-flex gap-2 mb-3">
            <div className="text-muted">
                <strong>
                    {label}
                </strong>
                {' '}
                {scopeObject.Name}
            </div>
            {canChange && (
                <GMetrixButton
                    className="p-0"
                    onClick={onChangeScope}
                    size="sm"
                    variant="link"
                >
                    {<FormattedMessage defaultMessage="Change" id="change.9018eebf" />}
                </GMetrixButton>
            )}
        </div>
    );

};
